

































import {
  Component,
  Vue,
  Config,
  TModelBase,
  Model,
  Watch,
  Prop,
} from "@/common";

import { TwTable } from "@/components";
import ShowMap from "./showMap.vue"
@Component({
  components:{
    ShowMap
  }
})
export default class OrderItems extends TModelBase {
  switchShowTModel(val) {
    if (val === true) {
      this.$http
        .get("Biz/Order/GetTrackList", {
          params: {
            Y_NO: this.propkey,
          },
        })
        .then((res) => {
          this.data.splice(0);
          this.data.push(...res.data.items);
        });
    }
  }

  @Prop({})
  private contrs!: Array<any>;

  @Prop({})
  private propkey!: String;

  get itemsTable(): TwTable {
    return this.$refs["itemsTable"] as TwTable;
  }

  show=false;

  dataLoading = false;

  saveMask = false;

  columns = [];

  data = [];

  mounted() {
    this.buildColumn("OrderTrack", this.columns);
  }

  renderHeader(h, params) {
    return (
      <span
        style="cursor:pointer;text-decoration: underline"
        onClick={() => {
          this.show=true;
        }}
      >
        <a >{params.column.label}</a>
        <i class="el-icon-map-location" style="margin-left:10px;color:orange" />
      </span>
    );
  }
}
